module.exports = __webpack_public_path__ + "12e9e2f28f79474f8cae1102cd8c092b.svg";